/**
 * Normalizes HTML by removing spaces between tags
 * This ensures consistent offset calculations between frontend and backend
 *
 * Example:
 *   Input:  "<p> mon</p>"  or  "<h1> a<p>b</h1>"
 *   Output: "<p>mon</p>"   or  "<h1>a<p>b</h1>"
 *
 * Note: Preserves spaces in text content like "5 < 10" or "x > y"
 */
export const parseSpacesBetweenTags = (html: string): string => {
  if (!html) return html

  return (
    html
      // Remove spaces between closing tag and opening tag: "</p> <h1>" → "</p><h1>"
      .replace(/(<\/[^>]+>)\s+(<[^/>][^>]*>)/g, '$1$2')
      // Remove spaces between opening tag and text, but only if tag starts element
      .replace(/(<[^/>][^>]*>)\s+/g, '$1')
      // Remove spaces before closing tag: " </p>" → "</p>"
      .replace(/\s+(<\/[^>]+>)/g, '$1')
      .trim()
  )
}
